import styled, { keyframes } from "styled-components";
import { brand_gradient, brand_orange_deep } from "../constants/styles";

const spin = keyframes`
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
`;

// Primary auth CTA — reuses the homepage's brand gradient for visual
// continuity with "Masuk" / "Explore" / "Kunjungi" pills.
const Button = styled.button`
  box-sizing: border-box;
  width: 100%;
  min-height: 48px;
  padding: 12px 24px;
  border: none;
  border-radius: 12px;
  background: ${brand_gradient};
  color: #ffffff;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 0.02em;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  box-shadow: 0 6px 16px rgba(216, 89, 7, 0.28);
  transition:
    transform 120ms ease,
    box-shadow 150ms ease,
    filter 150ms ease,
    opacity 150ms ease;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    filter: brightness(1.05);
    box-shadow: 0 10px 24px rgba(216, 89, 7, 0.36);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:focus-visible {
    outline: 3px solid ${brand_orange_deep};
    outline-offset: 3px;
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
    box-shadow: none;
  }
`;

const Spinner = styled.span`
  display: inline-block;
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.45);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: ${spin} 0.85s linear infinite;
`;

export default function SubmitButton({
  children,
  submitting,
  disabled,
  ...rest
}) {
  return (
    <Button
      type="submit"
      disabled={disabled || submitting}
      aria-busy={submitting || undefined}
      {...rest}
    >
      {submitting && <Spinner aria-hidden="true" />}
      <span>{children}</span>
    </Button>
  );
}
